import { render, staticRenderFns } from "./recordExchange.vue?vue&type=template&id=2620565c&scoped=true&"
import script from "./recordExchange.vue?vue&type=script&lang=js&"
export * from "./recordExchange.vue?vue&type=script&lang=js&"
import style0 from "./recordExchange.vue?vue&type=style&index=0&id=2620565c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620565c",
  null
  
)

export default component.exports